import {
  BLOCK_LINE,
  CLEAN_DATA,
  CREATE_LINE,
  CREATE_MOVIMIENTO,
  EDIT_MOVIMIENTO,
  ERROR,
  GET_LAST_CLIENT_DETAIL,
  GET_MOVIMIENTOS_BY_TYPE,
  GET_MOVIMIENTOS_LIST,
  GET_MOVIMIENTO_LINEA,
  APPROVE_MOVIMIENTO,
  DELETE_MOVIMIENTO,
} from '../constants/action-types';

const initialState = {
  approvedSuccess: false,
  clientList: {
    data: [],
    pages: 0,
    count: 0,
    previous: null,
    next: null,
  },
  clientTable: [],
  errorMessages: undefined,
  listData: {
    data: [],
    pages: 0,
    count: 0,
    previous: null,
    next: null,
  },
  lastClientDetail: null,
  lineDetail: null,
  movimientosList: {},
  successMessage: false,
  updateState: false,
};

const executeGetClientsSuccess = (state, action) => ({
  ...state,
  listData: {
    count: action.payload.count,
    data: action.payload.results,
    next: action.payload.next,
    pages: Math.ceil(action.payload.count / 20),
    previous: action.payload.previous,
  },
  errorMessages: undefined,
  successMessage: true,
});

const executeGetLastClientDetail = (state, action) => {
  const keys = Object.keys(action.payload.balance).filter(
    key => (key === 'exposicion_maxima') || (key === 'linea') || (key === 'cumulo' )
  );
  const clientTable = keys.map(key => {
    return {
      id: action.payload.id,
      key,
      monto: action.payload.balance[key],
      bloqueada: action.payload.balance.bloqueada,
    };
  });
  return {
    ...state,
    clientTable,
    lastClientDetail: action.payload,
    errorMessages: undefined,
  }
};

const executeGetMovimientoByTime = (state, action) => ({
  ...state,
  movimientosList: {
    count: action.payload.count,
    data: action.payload.results,
    next: action.payload.next,
    pages: Math.ceil(action.payload.count / 20),
    previous: action.payload.previous,
  },
  errorMessages: undefined,
  successMessage: true,
});

const executeGetLineaDetail = (state, action) => {
  return {
    ...state,
    lineDetail: action.payload,
  }
};

const executeCreateLineSuccess = (state) => {
  return {
    ...state,
    errorMessages: undefined,
    successMessage: true,
    updateState: true,
  }
};

const executeCleanEstadoSuccess = (state) => ({
  ...state,
  approvedSuccess: false,
  detalleEstado: undefined,
  errorMessages: undefined,
  lineDetail: null,
  successMessage: false,
  updateState: false,
});

const executeApproveMovimiento = (state, action) => {
  const { movimientosList, movimientosList: { data } } = state;
  const updatedMov = action.payload;
  return {
    ...state,
    approvedSuccess: true,
    movimientosList: {
      ...movimientosList,
      data: data.map(mov => mov.id === updatedMov.id ? updatedMov : mov)
    },
  }
};

const executeDeleteMovimiento = (state, action) => {
  const { movimientosList, movimientosList: { data } } = state;
  return {
    ...state,
    movimientosList: {
      ...movimientosList,
      data: data.filter(mov => mov.id !== action.payload)
    }
  }
};

const handleError = (state, action) => {
  const errors = [];
  Object.values(action.payload).forEach(errorList => {
    if (Array.isArray(errorList)) {
      errorList.forEach(error => {
        errors.push(error[0].toUpperCase() + error.slice(1))
      })
    } else {
      errors.push(errorList[0].toUpperCase() + errorList.slice(1))
    }
  });

  if (errors) {
    return {
      ...state,
      errorMessages: errors,
    }
  }

  return {
    ...state,
    errorMessages: ['Ha sucedido un error, por favor vuelva a intentarlo más tarde'],
  }
};


const executeBlockLineSuccess = (state, action) => ({
  ...state,
  errorMessages: undefined,
  lastClientDetail: {
    ...state.lastClientDetail,
    balance: action.payload.balance,
  },
});

function clients(state = initialState, action) {
  switch (action.type) {
    case APPROVE_MOVIMIENTO:
      return executeApproveMovimiento(state, action);
    case BLOCK_LINE:
      return executeBlockLineSuccess(state, action);
    case CLEAN_DATA:
      return executeCleanEstadoSuccess(state);
    case CREATE_LINE:
      return executeCreateLineSuccess(state, action);
    case CREATE_MOVIMIENTO:
      return executeCreateLineSuccess(state, action);
    case DELETE_MOVIMIENTO:
      return executeDeleteMovimiento(state, action);
    case EDIT_MOVIMIENTO:
      return executeCreateLineSuccess(state, action);
    case ERROR:
      return handleError(state, action);
    case GET_LAST_CLIENT_DETAIL:
      return executeGetLastClientDetail(state, action);
    case GET_MOVIMIENTOS_BY_TYPE:
      return executeGetMovimientoByTime(state, action);
    case GET_MOVIMIENTOS_LIST:
      return executeGetClientsSuccess(state, action);
    case GET_MOVIMIENTO_LINEA:
      return executeGetLineaDetail(state, action);
    default:
      return state;
  }
}

export default clients;
